import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethirteen-popular-courses',
  templateUrl: './homethirteen-popular-courses.component.html',
  styleUrls: ['./homethirteen-popular-courses.component.scss']
})
export class HomethirteenPopularCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
